import anotherCollectionReducer from './anotherCollectionReducer';
import collectionReducer from './collectionReducer';

export default {
  collection: collectionReducer,
  anotherCollection: anotherCollectionReducer,
};
